// src/components/LinkButton.jsx
import React from 'react';
import cx from 'classnames';

export default function LinkButton({ title, url, stripStyle, radius, fontColor }) {
  return (
    <div className="canario-form-btn-container">
      <div className="canario-form-bnt-wrap" style={{ borderRadius: radius, position: 'relative' }}>
        <div className="canario-form-btn-color" style={stripStyle} />
        <a
          className={cx('canario-form-btn')}
          href={url}
          target="_blank"
          rel="noopener"
          style={{ color: fontColor }}
        >
          {title}
        </a>
      </div>
    </div>
  );
}
